import Modal from '@components/Modals/Interview';
import { ATTENDEE_TYPE } from '@constants/attendee';
import { useGetPath } from '@hooks/interview/useGetPath';
import { useInterviewAPI } from '@hooks/interview/useInterviewAPI';
import { useInterviewSession } from '@hooks/interview/useInterviewSession';
import { useMeetingManager } from '@providers/MeetingProvider';
import type { MouseEventHandler } from 'react';
import { useState, type FC } from 'react';
import { Container, IconWrapper } from './style';
import SpeakerIcon from '/icon/meetingOut.svg';

const ExitToggle: FC = () => {
  const { attendeeType } = useGetPath();
  const meetingManager = useMeetingManager();
  const { getInterviewInfo } = useInterviewSession();
  const { leaveAttendeeInterview, leaveManagerInterview } = useInterviewAPI();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleExit = async () => {
    setIsModalOpen(true);
  };

  const onConfirm: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.stopPropagation();

    const { certificationCode, valuerSn } = getInterviewInfo();

    if (certificationCode && valuerSn) {
      switch (attendeeType) {
        case ATTENDEE_TYPE.INTERVIEWER:
          await leaveManagerInterview({ certificationCode, valuerSn });
          break;

        default:
          await leaveAttendeeInterview({ certificationCode, valuerSn });
          break;
      }
    }

    meetingManager.leave();
    window.close();
  };

  const onCancel: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setIsModalOpen(false);
  };

  return (
    <Container onClick={handleExit}>
      <IconWrapper>
        <img src={SpeakerIcon} alt={'스피커'} />
      </IconWrapper>
      <span>나가기</span>
      {isModalOpen && (
        <Modal onClickConfirm={onConfirm} onClickCancel={onCancel}>
          면접을 종료하고 나가시겠습니까?
        </Modal>
      )}
    </Container>
  );
};

export default ExitToggle;
